import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useScrollRestoration() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on new page load or when navigating to TeamPage
    if (location.pathname === '/TeamSection') {
      window.scrollTo(0, 0);
    } else {
      // Scroll to top on other page loads
      window.scrollTo(0, 0);
    }

    // Save scroll position before navigating away
    const saveScrollPosition = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY);
    };

    // Restore scroll position when navigating back
    const restoreScrollPosition = () => {
      const scrollPosition = sessionStorage.getItem('scrollPosition');
      if (scrollPosition !== null) {
        window.scrollTo(0, parseInt(scrollPosition, 10));
      }
    };

    // Add event listener to save scroll position
    window.addEventListener('beforeunload', saveScrollPosition);

    // Restore scroll position on component mount
    restoreScrollPosition();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, [location.pathname]);
}

export default useScrollRestoration;